import * as moment from 'moment';
import {Component, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DateService} from '../_services/date.service';
import {SoService} from '../../shared/_services/so.service';
import {DATE_FORMAT} from '../_models/date.model';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss']
})

export class DateComponent implements OnDestroy {

  curDate: moment.Moment;
  dateActive = false;

  horAsOf: number;
  horUpTo: number;
  horDays = new Array<number>(12).fill(0).map((_, i) => i + 3);

  // DESTROY SUBJECT
  onDestroy$: Subject<void> = new Subject<void>();

  daFilter = (d: Date | null): boolean => {
    return moment(d).isBefore(moment().startOf('day').add(2, 'days'));
  }

  constructor(
    private dateService: DateService,
    private soService: SoService,
  ) {
    this.getSo();
    this.onNewDate();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  // ********************************************************************************************************
  // LOADING DATA
  // ********************************************************************************************************

  private onNewDate(): void {
    this.dateService.onNewDate()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (date) => {
          if (date) {
            this.horAsOf = date.horAsOf;
            this.curDate = moment(date.date);
            this.horUpTo = date.horUpTo;
          }
        }
      );
  }

  private getSo(): void {
    this.soService.onNewSoActive()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (so) => {
          this.dateActive = so === 'date';
        }
      );
  }

  // ********************************************************************************************************
  // UI
  // ********************************************************************************************************

  // EVENT LISTENERS

  onChangeDate(e: any): void {
    this.dateService.newDate({
      horAsOf: this.horAsOf,
      date: moment(e).format(DATE_FORMAT),
      horUpTo: this.horUpTo,
    });
  }

  onChangeHor(): void {
    this.dateService.newDate({
      horAsOf: this.horAsOf,
      date: this.curDate.format(DATE_FORMAT),
      horUpTo: this.horUpTo,
    });
  }

}
